import { extendTheme } from '@mui/material/styles';
import { colors } from './colors';

declare module '@mui/material/styles' {
  interface Palette {
    custom: {
      pastelBlue: string;
      pastelRed: string;
    };
  }
  interface PaletteOptions {
    custom?: {
      pastelBlue: string;
      pastelRed: string;
    };
  }
}

const dashboardTheme = extendTheme({
  colorSchemes: {
    light: true,
    dark: {
      palette: {
        background: {
          default: colors.backgroundDark,
          paper: colors.backgroundDark,
        },
      },
    },
  },
  colorSchemeSelector: 'class',
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1400,
      lg: 1700,
      xl: 2500,
    },
  },
});

export default dashboardTheme;
